import { type ChartingNoncomplianceState } from "@src/appV2/redesign/Charting/api/schema";

export const CHARTING_REVIEW_DURATION_IN_HOURS = 72;

export const CHARTING_ERROR_CODES = {
  MISSING_COORDINATES: "missing-coordinates",
  OUTSIDE_GEOFENCE: "outside-geofence",
  PATCH_FAILED: "patch-failed",
} as const;

export const SEEN_CHARTING_NONCOMPLIANCE_ID_STORAGE_KEY = "seen-charting-noncompliance-id";
export const CHARTING_REDIRECT_PATH = "/home-v2/shift-discovery/list?chartingRedirect=true";
export const CHARTING_CARD_IMAGE_PADDING = 110;

export const ACTIVE_CHARTING_NONCOMPLIANCE_STATES: ChartingNoncomplianceState[] = [
  "recalled",
  "review",
  "violation",
];

export const SHIFT_CREDENTIALS_CONFIRMATION_KEY = "shift-credentials-confirmation";
export const WORKPLACE_CREDENTIALS_CONFIRMATION_KEY = "workplace-credentials-confirmation";

export const HIDDEN_PASSWORD_TEXT = "●●●●●●●";
